import React, { useState } from 'react'
import { getLanguageLabel } from '../../../helpers/language';
import { useGetLanguageApp, useSetLanguageApp } from '../../../stores/app.store';
import { ChevronDown, ChevronUp, Globe } from 'react-bootstrap-icons';
import { Languages } from '../../../enums/languages';

const SmallSelectLanguage = () => {

    const [isHovered, setIsHovered] = useState(false);
    const [hoverOption, setHoverOption] = useState<-1 | Languages>(-1);
    const setLanguage = useSetLanguageApp();
    const currentLanguage = useGetLanguageApp();

    const currentLanguageLabel = getLanguageLabel(currentLanguage);

    return (
        <div
            style={{ position: 'relative', cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: '0.25rem' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                <Globe />

                <div >{currentLanguageLabel}</div>

                {isHovered ? <ChevronUp /> : <ChevronDown />}
            </div>

            <div
                style={{
                    display: isHovered ? 'flex' : 'none',
                    flexDirection: 'column',
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    alignItems: 'center',
                    backgroundColor: 'white',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                }}
            >
                <div
                    onMouseEnter={() => setHoverOption(Languages.Hebrew)}
                    onMouseLeave={() => setHoverOption(-1)}
                    onClick={() => handleOnClicked(Languages.Hebrew)}
                    className='text-center'
                    style={{
                        width: '100%',
                        padding: '0.25rem',
                        backgroundColor: hoverOption === Languages.Hebrew ? '#f0f0f0' : 'transparent'
                    }}
                >
                    עברית
                </div>

                <div
                    onMouseEnter={() => setHoverOption(Languages.English)}
                    onMouseLeave={() => setHoverOption(-1)}
                    onClick={() => handleOnClicked(Languages.English)}
                    className='text-center'
                    style={{
                        width: '100%',
                        padding: '0.25rem',
                        backgroundColor: hoverOption === Languages.English ? '#f0f0f0' : 'transparent'
                    }}
                >
                    English
                </div>
            </div>
        </div>
    );

    function handleOnClicked(language: Languages) {

        setIsHovered(false);
        setLanguage(language);
    }

    /*
    <div
    onMouseEnter={() => setHoverOption(Languages.Arabic)}
    onMouseLeave={() => setHoverOption(-1)}
    onClick={() => handleOnClicked(Languages.Arabic)}
    className='text-center'
    style={{
        width: '100%',
        padding: '0.25rem',
        backgroundColor: hoverOption === Languages.Arabic ? '#f0f0f0' : 'transparent'
    }}
>
    العربية
</div>
    */
}

export default SmallSelectLanguage;